<template>
  <div class="adp-catalog-wrapper">
    <div class="d-flex justify-content-between hide-mobile" v-if="role === 'employee'">
      <div class="d-flex justify-content-between">
        <button class="btn adp-btn" @click="chooseActivity(group, false)">{{ $t('catalog.add_to_idp') }}</button>

        <div class="d-flex align-items-center ml-3 position-relative align-self-center align-content-center align-self-center">
          <span class="adp-p adp-p__bold mr-2">{{ $t('catalog.assign_as') }}</span>
          <activity-type-select :options="groups" :init-selected="group" v-on:my-change="selectAssignActivityType($event)">
          </activity-type-select>
        </div>
      </div>
      <div style="margin-bottom: -12px;">
        <span class="adp-p adp-p__small">{{ $t('catalog.dont_you_found') }}</span> <br>
        <span class="adp-p adp-p__small adp-p__grey">{{ $t('catalog.you_cat_create_new') }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between hide-mobile" v-if="role === 'hr' || role === 'admin' || role === 'manager'">
      <div class="d-flex justify-content-between">
        <button class="btn adp-btn mr-1" @click="$bvModal.show('common-event-create-modal')" v-if="role === 'hr' || role === 'admin' ">
          {{ $t('catalog.create_event') }}
        </button>

        <button v-if="pernumber && !employeesFromHr.length"
                class="btn adp-btn mr-1" @click="chooseActivity(group, false)"
                :disabled="!Object.keys(assignItems).length">{{ $t('catalog.add_to_idp') }}
        </button>

        <button v-if="employeesFromHr.length"
                class="btn adp-btn mr-1" @click="chooseActivity(group, false)"
                :disabled="!Object.keys(assignItems).length">{{ $t('catalog.add_to_idp') }}
        </button>

        <span class="d-flex align-items-center ml-2 mr-4 position-relative align-self-center align-content-center align-self-center"
              v-if="pernumber || employeesFromHr.length">
          <span class="adp-p adp-p__bold mr-2">{{ $t('catalog.assign_as') }}</span>
          <activity-type-select :options="groups" :init-selected="group" v-on:my-change="selectAssignActivityType($event)">
          </activity-type-select>
        </span>

        <button v-else
                class="btn adp-btn mr-1" @click="openMassAssignments(true, group)"
                :disabled="!Object.keys(assignItems).length">{{ $t('catalog.assign') }}
        </button>

<!--        Create template button-->
<!--        <button class="btn adp-btn adp-btn__green" v-if="Object.keys(assignItems).length" @click="createTemplate()">{{ $t('catalog.create_template') }}</button>-->

      </div>

      <div class="d-flex justify-content-between align-items-center">

<!--        Filter by template dropdown-->
<!--        <span class="adp-p adp-p__bold mr-2">{{ $t('catalog.template') }}</span>-->
<!--        <my-template-filter :options="hrTemplates" :init-selected="filterTemplates"-->
<!--                            v-on:my-change="selectTemplate($event)" v-on:edit-template="editTemplate($event)">-->
<!--        </my-template-filter>-->

        <span class="adp-p__grey" v-html="$t('catalog.if_not_found_create_new')"></span>
      </div>
    </div>

    <div class="hide-pc adp-fulltext">
      <span class="adp-p adp-p__small adp-p__grey">{{ $t('catalog.search_any_way') }}</span>
      <input type="text" class="adp-input adp-input__catalog adp-input-search" style="margin-top: 6px;">
    </div>
    <div class="adp-grid-table">
      <div class="adp-grid-row hide-mobile" :class="{ 'adp-grid-row__hr': role === 'hr' || role === 'admin' || role === 'manager' }">
        <div class="adp-grid-cell adp-grid-cell__chbox">
          <b-form-checkbox v-model="selectAllAll" :indeterminate="selectAllIndeterminate" @change="selectAll($event)">&nbsp;</b-form-checkbox>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingName !== null}" @click="sortChange('sortingName')">
            {{ $t('catalog.name') }} <img :src="getSortingIcon(sortingName)" alt="sort">
          </span>
          <input @input="filterAndSortItems" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingCompetence !== null}" @click="sortChange('sortingCompetence')">
            {{ $t('catalog.competencies') }} <img :src="getSortingIcon(sortingCompetence)" alt="sort">
          </span>
          <div class="position-relative" v-click-outside="() => hide('isActiveCompetence')">
              <input type="text" class="adp-input adp-input__catalog" @click="isActiveCompetence = true"
                     @input="searchCompetence($event)" ref="competence-input">
              <img src="/images/arrow_grey.svg" class="my-dropdown-arrow">
              <my-tree-filter :competencies="competenciesTree" :is-visible="isActiveCompetence"
                              @root-change="onChildrenUpdate" v-if="!searching"/>
          </div>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingFormatAndMethods !== null}" @click="sortChange('sortingFormatAndMethods')">
            {{ $t('catalog.format') }} <img :src="getSortingIcon(sortingFormatAndMethods)" alt="sort">
          </span>
          <my-dropdown :options="formatsAndMethods" :init-selected="filterFormatsMethods" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterFormatsMethods')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingType !== null}" @click="sortChange('sortingType')">
            {{ $t('catalog.type') }} <img :src="getSortingIcon(sortingType)" alt="sort">
          </span>
          <my-dropdown :options="types" :init-selected="filterTypes" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterTypes')">
          </my-dropdown>
        </div>
      </div>
      <div class="adp-grid-row" :class="{ 'adp-grid-row__hr': role === 'hr' || role === 'admin' || role === 'manager', 'adp-grid-row__warning': !item.is_valid }"
           v-for="(item, i) in learningItems" style="cursor: pointer" @click="showViewModalByClick(item)">
        <div class="adp-grid-cell adp-grid-cell__chbox" @click.stop>
          <b-form-checkbox :disabled="!item.is_valid" v-model="item.is_checked" @change="selectEvent($event, i)">&nbsp;</b-form-checkbox>
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          <span class="adp-p adp-p__bold">{{ item.name }}</span>
        </div>
        <div class="adp-grid-cell">
        <span class="adp-p">
          <template v-if="item.competencies.length">
            {{
              item.competencies.map(e => {
                if (competenciesMap[e]) {
                  return competenciesMap[e][`name_${$i18n.locale}`]
                } else {
                  return e;
                }
              }).join(', ')
            }}
          </template>
        </span>
        </div>
        <div class="adp-grid-cell">
          <span class="adp-p adp-p__grey">{{ $t(`idp.${item.format_method}`) }}</span>
        </div>
        <div class="adp-grid-cell adp-grid-cell__type position-relative">
          <span class="adp-p adp-p__grey">{{ $t(`idp.${item.type}`) }}</span>
          <div class="adp-kebab">
            <img src="/images/red_warning.svg" alt="" v-tooltip.top-end="{ content: $t('catalog.not_fully_valid') }" style="cursor: pointer;" v-if="!item.is_valid">
            <img src="/images/vertical_dots.svg" alt="" style="padding: 2px 6px; cursor: pointer;" @click.stop="openCM($event, item.id, item.type)">
          </div>
        </div>
      </div>
    </div>
    <div class="adp-pagination">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
          :options="itemsPerPage"
          :clearable="false"
          v-model="itemsPerPageSelected"
          @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>

    <!-- Context Menu -->
    <div class="adp-task--crud-actions" :style="cmStyles" v-if="contextMenu.isVisible" v-click-outside="() => hideCM()" ref="contextMenu">
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="role === 'hr' || role === 'admin'" @click="showViewModal();">
        {{ $t('catalog.edit') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="role === 'manager' || role === 'employee'" @click="showViewModal();">
        {{ $t('catalog.view') }}
      </div>
      <template v-if="contextMenuActivity.isValid">
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="openMassAssignments(false, 'mandatory')"
             v-if="(role === 'hr' || role === 'admin' || role === 'manager') && !pernumber">
          {{ $t('catalog.add_as_mandatory') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="openMassAssignments(false, 'additional')"
             v-if="(role === 'hr' || role === 'admin' || role === 'manager') && !pernumber">
          {{ $t('catalog.add_as_additional') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="chooseActivity('mandatory', true)"
             v-if="role === 'employee' || !!pernumber">
          {{ $t('catalog.add_as_mandatory') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="chooseActivity('additional', true)"
             v-if="role === 'employee' || !!pernumber">
          {{ $t('catalog.add_as_additional') }}
        </div>
      </template>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="openAssignmentsModal"
           v-if="role === 'hr' || role === 'admin' || role === 'manager'">
        {{ $t('catalog.view_assignment') }}
      </div>
    </div>

    <!-- Modal -->
    <common-event-view-modal :activity-id="Number(contextMenuActivity.activityId)"
                             :activity-type="String(contextMenuActivity.activityType)"
                             @updateActivities="getActivities"
                             :is-editable="false"
                             :is-edit="Boolean(contextMenu.isEdit)">
    </common-event-view-modal>
    <deadline-modal v-if="activities.length && !employeesFromHr.length"
                    :activity="activities[0]"
                    :idp-status="String(IDP.status)"
                    @setDeadline="assignActivity"
                    @closeDeadlineModal="deleteActivity">
    </deadline-modal>

    <mass-assignment-modal v-if="showMassAssignments"
                           :groups="groups"
                           :group="group"
                           :learning-activity-ids="assignItems"
                           :learning-activity="contextMenuActivity"
                           @close-modal="closeMassAssignmentsModal()"
    >
    </mass-assignment-modal>

    <b-modal id="catalog-alert-assignments-modal" hide-footer
             :modal-class="`adp-modal adp-modal__no_footer catalog-mass-assignments-alert-modal mass-assignments-alert-modal`"
             :body-class="`adp-modal-body`">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template>
        <div class="mass-assignments-alert">
          {{ $t('catalog.assign_need_activity') }}
        </div>
      </template>
    </b-modal>

    <b-modal id="alert-assign-modal-list" hide-footer
             :modal-class="`adp-modal adp-modal__no_footer mass-assignments-alert-modal`"
             :body-class="`adp-modal-body`">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template>
        <div class="mass-assignments-alert" v-for="assignedActivity in assignedActivities">
          {{ $t('catalog.learning') }}
          {{ assignedActivity }}
          {{ $t('catalog.learning_already_exists') }}
          <br><br>
<!--          <p class="mass-assignments-alert-link" @click="goToMyIDP">-->
<!--            {{ $t('catalog.go_to_my_idp') }}-->
<!--          </p>-->
        </div>
      </template>
    </b-modal>

    <common-event-create-modal :learning-activity-group="'mandatory'"
                               @updateActivities="getActivities"
                               :employee-type="''">
    </common-event-create-modal>

    <template-modal :template="editTemplateData" :template-id="editTemplateId" :selected-items="assignItems"
                    @template-created="updateTemplates">
    </template-modal>
    <assignments-view-modal v-if="!isNaN(Number(contextMenuActivity.activityId)) && String(contextMenuActivity.name) !== undefined"
                            :activity-id="Number(contextMenuActivity.activityId)"
                            :activity-name="String(contextMenuActivity.name)">
    </assignments-view-modal>

    <div v-for="(activity, i) in activities" :key="i" v-if="employeesFromHr.length">
      <mass-deadlines-modal :activity="activity" :activities-group="group" :activity-index="i" />
    </div>
  </div>
</template>

<script>
import { find, findIndex } from 'lodash';
import AssignmentsViewModal from './modals/AssignmentsViewModal';
import MyDropdown from './MyDropdown';
import MyTreeFilter from './MyTreeFilter';
import MyTemplateFilter from "./MyTemplateFilter";
import Tree from "../map";
import api from "../api";
import CommonEventViewModal from "./modals/CommonEventViewModal";
import CommonEventCreateModal from "./modals/CommonEventCreateModal";
import DeadlineModal from "./modals/DeadlineModal";
import TemplateModal from "./modals/TemplateModal";
import MassAssignmentModal from "./modals/MassAssignmentsModal";
import ActivityTypeSelect from "./ActivityTypeSelect";
import MassDeadlineModal from "./modals/MassDeadlineModal";

export default {
  name: "Catalog",
  components: {
    'assignments-view-modal': AssignmentsViewModal,
    'activity-type-select': ActivityTypeSelect,
    'my-dropdown': MyDropdown,
    'my-tree-filter': MyTreeFilter,
    'my-template-filter': MyTemplateFilter,
    'common-event-view-modal': CommonEventViewModal,
    'common-event-create-modal': CommonEventCreateModal,
    'template-modal': TemplateModal,
    'mass-assignment-modal': MassAssignmentModal,
    'deadline-modal': DeadlineModal,
    'mass-deadlines-modal': MassDeadlineModal,
  },
  data: function () {
    return {
      itemsPerPage: [
        {number: 20, text: '20 на странице'},
        {number: 50, text: '50 на странице'},
        {number: 100, text: '100 на странице'},
      ],
      itemsPerPageCount: 20,
      role: 'employee',

      selectAllAll: false,
      selectAllIndeterminate: false,

      allItems: [],
      items: [],

      filterCode: '',

      filterName: '',
      names: [],

      filterFormatsMethods: [],
      formatsAndMethods: [],

      filterCompetencies: [],
      competenciesMap: [],
      competenciesTree: [],

      filterTypes: [],
      types: [],

      filterTemplates: [],
      hrTemplates: [],
      editTemplateId: 0,
      editTemplateData: {},

      sortingCode: null,
      sortingName: null,
      sortingCompetence: null,
      sortingFormatAndMethods: null,
      sortingType: null,

      isActiveCompetence: false,
      isActiveFormatAndMethods: false,
      isActiveType: false,

      pages: [],
      activePage: 1,

      contextMenu: {
        isVisible: false,

        activityId: null,
        activityType: null,
        activity: {},

        isEdit: true,
        top: 0,
        left: 0,
      },

      contextMenuActivity: {},

      assignItems: {},
      showMassAssignments: false,

      group: 'mandatory',
      pernumber: '',
      assignedActivities: [],
      groups: ['mandatory', 'additional'],
      activities: [],
      activitiesGroup: null,
      IDP: null,

      employeesFromHr: [],

      currentYear: new Date().getFullYear(),
      commonCompetenceTree: {},
      filterCompetenceName: '',
      searching: false,
    }
  },
  watch: {

  },
  computed: {
    cmStyles() {
      return {
        top: `${this.contextMenu.top}px`,
        left: `${this.contextMenu.left}px`,
        right: 'unset',
      };
    },
    itemsPerPageSelected: {
      get() {
        return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
      },
      set({number}) {
        this.itemsPerPageCount = number;
      }
    },
    learningItems() {
      return this.role === 'employee'
        ? this.items.filter((x) => x.is_valid)
        : this.items;
    },
  },
  methods: {
    async closeMassAssignmentsModal() {
      await this.getActivities(this.activePage);
      await this.getIdp();
      await this.getEmployeesFromEmployeeList();

      this.assignItems = {};
      this.selectAllAll = false;
      this.selectAllIndeterminate = false;
    },
    updateItemsChecked() {
      let items = {};

      let assignedItems = this.items.filter(el => el.is_checked).map(el => {
        return {
          activityId: el.id, activityType: el.type, personalType: el.personal_type,
          name: el.name, group: 'additional'
        }
      });

      assignedItems.forEach(item => {
        items[item.activityId] = item
      })

      this.assignItems = items;
    },
    updateTemplates() {
      this.editTemplateId = 0;
      this.editTemplateData = {};

      const currState = Object.fromEntries(new URLSearchParams(window.location.search));
      this.getTemplates(currState);
    },
    async filterAndSortItems() {
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }

      let items = this.allItems;
      items = await this.searchItems();

      if (this.filterTemplates.length > 0) {
        const tpl = this.hrTemplates.find((el) => el.id === parseInt(this.filterTemplates[0]));
        if (tpl && tpl.events && tpl.events.length > 0) {
          const eventsId = tpl.events.map(el => el.id);
          items = items.filter(el => eventsId.includes(el.id));
        }
      }

      // возвращаем сортировку в исходное положение(сортируем по id)
      items = items.sort(dynamicSort('id'));

      if (this.sortingCode) {
        let co = this.sortingCode === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}id`));
      } else if (this.sortingName) {
        let co = this.sortingName === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}name`));
      } else if (this.sortingCompetence) {
        let co = this.sortingCompetence === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}name`));
      } else if (this.sortingFormatAndMethods) {
        let co = this.sortingFormatAndMethods === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}format_method`));
      } else if (this.sortingType) {
        let co = this.sortingType === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}type`));
      }

      items.forEach(el => el.is_checked = false);
      this.items = JSON.parse(JSON.stringify(items));
    },
    async searchItems() {
      let items = this.allItems;
      let data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        search_name: this.filterName,
        search_competence: this.filterCompetencies,
        search_competence_name: this.filterCompetenceName,
        search_format: this.filterFormatsMethods,
        search_type: this.filterTypes,
      };

      let resp = await api.getCatalog(data);
      items = resp.data.data;
      this.allItems = resp.data.data;
      this.pages = resp.data.meta.links;

      return items;
    },
    onChildrenUpdate(cmptcs) {
      let checkedCompetencies = new Set();
      cmptcs.map(cmptns => flatten(cmptns));

      function flatten(cmptns) {
        if (cmptns.isCompetence && cmptns.isChecked) {
          checkedCompetencies.add(cmptns.id)
        }
        if (cmptns.children && cmptns.children.length) {
          cmptns.children.map(cmp => flatten(cmp));
        }
      }
      this.filterCompetencies = Array.from(checkedCompetencies);
      this.filterAndSortItems();
    },
    onDropdownUpdate(e, property) {
      this[property] = e;
      this.filterAndSortItems();
    },
    openCM(event, activityId, activityType) {
      this.contextMenu.activityId = activityId;
      this.contextMenu.activityType = activityType;

      this.contextMenu.top = event.pageY;
      this.contextMenu.left = event.pageX - 231;

      this.contextMenu.isVisible = true;

      let activeItem = this.items.find(el => el.id === this.contextMenu.activityId);

      this.contextMenuActivity = {
        activityId: activeItem.id,
        activityType: activeItem.type,
        name: activeItem.name,
        group: 'additional',
        isValid: activeItem.is_valid
      };
    },
    hideCM() {
      this.contextMenu.isVisible = false;
      this.contextMenu.activityId = '';
      this.contextMenu.activityType = '';
    },
    hide(prop) {
      this[prop] = false;
    },
    sortChange(prop) {
      if (this[prop] === null) {
        this[prop] = 'asc';
      } else if (this[prop] === 'asc') {
        this[prop] = 'desc';
      } else if (this[prop] === 'desc') {
        this[prop] = null;
      }

      this.filterAndSortItems();
    },
    getSortingIcon(val) {
      if (val === null) {
        return '/images/sort.svg';
      } else if (val === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (val === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    changePage(val) {
      if(val === '...') {
        return;
      }

      if(val === 'pagination.previous') {
        val = Number(this.activePage) - 1;
      }

      if(val === 'pagination.next') {
        val = Number(this.activePage) + 1;
      }

      val = Number(val);

      this.activePage = val;
      if (val === 1) {
        val = null;
      }
      this.getActivities();
    },
    boldString(str, substr) {
      if (!str || !substr) {
        return;
      }
      let lowerCaseSrt = str.toLowerCase();
      let lowerCaseSubstr = substr.toLowerCase();
      let i = lowerCaseSrt.indexOf(lowerCaseSubstr);
      if (i < 0) {
        return ;
      }
      const splitOn = (slicable, ...indices) =>
        [0, ...indices].map((n, i, m) => slicable.slice(n, m[i + 1]));
      let tokens = splitOn(str, i, i+substr.length);
      if (tokens.length !== 3) {
        return;
      }
      return `${tokens[0]}<b>${tokens[1]}</b>${tokens[2]}`;
    },
    showViewModal() {
      this.$bvModal.show('common-event-view-modal');
    },
    openMassAssignments(withChecked, group) {
      this.group = group;
      if(withChecked) {
        this.contextMenuActivity = {};
      }

      if (Object.keys(this.assignItems).length || this.contextMenu.activityId) {
        this.showMassAssignments = true;
        setTimeout(() => {
          this.$bvModal.show('mass-assignments-modal');
          $('.adp-navbar').addClass('adp-navbar-fixed');
        }, 100);
      } else {
        this.$bvModal.show('catalog-alert-assignments-modal');
      }
    },

    createTemplate() {
      this.$bvModal.show('template-modal');
    },
    editTemplate(e) {
      this.editTemplateId = e.id;

      this.editTemplateData = this.hrTemplates.find(el => {
        return this.editTemplateId === el.id;
      });
      this.$nextTick(() => {
        this.$bvModal.show('template-modal');
      });
    },
    selectTemplate(e) {
      this.filterTemplates = e;
      this.filterAndSortItems();
    },

    fetchNames(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.search(loading, search, this);
      }
    },

    selectAll(e) {
      if (Object.keys(this.assignItems).length) {
        this.items = this.items.map(el => {el.is_checked = false; return el});
        this.selectAllAll = false;
      } else {
        this.items = this.items.map(el => {el.is_checked = true; return el});
        this.selectAllAll = true;
      }
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
    },

    selectEvent(e, i) {
      let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
      if (this.items.length === checkedElementsCnt) {
        this.selectAllAll = true;
        this.selectAllIndeterminate = false;
      } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
        this.selectAllAll = false;
        this.selectAllIndeterminate = true;
      } else {
        this.selectAllAll = false;
        this.selectAllIndeterminate = false;
      }

      this.updateItemsChecked();
    },

    selectAssignActivityType(group) {
      this.group = group;
    },

    chooseActivity(group, fromContextMenu = false) {
      let elToAssign = this.items.filter(el => el.is_checked).map(el => {
        return { activityId: el.id, activityType: el.type, name: el.name, start_at: el.start_at,
          end_at: el.end_at,}
      });

      if (!elToAssign.length && !this.contextMenu.activityId) {
        this.$bvModal.show('catalog-alert-assignments-modal');
        return;
      }

      let activities = elToAssign;

      if (fromContextMenu) {
        let activity = this.allItems.find((el) => {
          return el.id === this.contextMenu.activityId;
        });

        activities = [{
          activityId: this.contextMenu.activityId,
          activityType: activity.type,
          name: activity.name,
          start_at: activity.start_at,
          end_at: activity.end_at,
        }];
      }

      this.activitiesGroup = this.group;
      if (group) this.activitiesGroup = group;

      this.activities = activities;
      this.assignedActivities = [];

      if (this.employeesFromHr.length) {
        this.$nextTick(() => {
          this.$bvModal.show('mass-deadlines-modal');
        })
      } else {
        this.$nextTick(() => {
          this.$bvModal.show('deadline-modal');
        })
      }
    },

    assignActivity(activityId, deadline) {
      const activity = find(this.activities, activityItem => activityItem.activityId === activityId);
      let data = {
        activityId: activityId,
        activityType: activity.activityType,
        group: this.activitiesGroup,
        role: this.role,
        participant_pernumber: this.pernumber,
        deadline,
      };

      let assignedActivities = [];

      let resp = api.assignCatalogEvent(data);

      resp.then((response) => {
        if (response.data.success && response.status === 200 && this.activities.length === 1 && !this.assignedActivities.length) {
          if (this.role === 'employee') {
            window.location.pathname = "/" + this.role;
          } else {
            window.location.pathname = "/" + this.role + "/employee/" + this.pernumber;
          }
        } else if (response.data.assignedActivities && Object.keys(response.data.assignedActivities).length) {

          for (let [key, value] of Object.entries(response.data.assignedActivities)) {
            let activity = this.allItems.find(el => el.id === value.idps_learning_activity_id);

            assignedActivities.push(activity.name)
          }

          this.assignedActivities.push(...assignedActivities);
        }

        this.deleteActivity(activityId);
      }).catch((e) => {
        console.log(e);
      })
    },

    deleteActivity(activityId) {
      const activityIndex = findIndex(this.activities, activityItem => activityItem.activityId === activityId);
      this.activities.splice(activityIndex, 1);

      if (!this.activities.length && this.assignedActivities.length) {
        setTimeout(() => {
          this.$bvModal.show('alert-assign-modal-list');
        }, 200);
      }
    },

    async search(loading, search, vm) {
      try {
        let res = await api.searchCommonEvents(search);
        this.names = res.data.map(el => el.name);
        this.filterName = search;

        this.filterAndSortItems();
      } catch (e) {
        console.error(e);
      }
      loading(false);
    },

    async getCompetences(filterCompetencies) {
      try {
        let resp = await api.getCompetences();
        this.competenciesTree = resp.data.map(r =>  {
          return Tree.map(Tree.mapFilterFormat, r, {}, filterCompetencies)
        });

        let competencies = {};

        function updateCheckboxes(el) {
          if (el.isCompetence) {
            competencies[el.id] = {
              name_ru: el.name_ru,
              name_en: el.name_en,
              name_fr: el.name_fr,
            }
          }

          if (el.children && el.children.length) {
            el.children = el.children.map(cmp => updateCheckboxes(cmp));

            if (el.children.length > 0) {
              let indeterminateEl = el.children.reduce((ac, subEl) => +(subEl.isIndeterminate) + ac, 0);
              let checkedEl = el.children.reduce((ac, subEl) => +(subEl.isChecked) + ac, 0);
              if (checkedEl === el.children.length) {
                el.isChecked = true;
              } else if (checkedEl > 0 || indeterminateEl) {
                el.isIndeterminate = true;
              }
            }
          }
          return el;
        }
        this.competenciesTree.map(el => updateCheckboxes(el));
        this.commonCompetenceTree = [...this.competenciesTree];

        this.competenciesMap = competencies;
        this.filterCompetencies.splice(0, this.filterCompetencies.length, ...Array.from(new Set(filterCompetencies)).sort());
      } catch (e) {
        console.error(e);
      }
    },
    async getActivities() {
      this.$bvModal.hide('common-event-view-modal');
      this.$bvModal.hide('common-event-create-modal');
      this.$bvModal.hide('deadline-modal');
      this.$bvModal.hide('assignments-view-modal');

      this.loading = true;
      try {
        const data = {
          page: this.activePage,
          count: this.itemsPerPageCount,
        };
        let resp = await api.getCatalog(data);
        this.allItems = resp.data.data;
        this.pages = resp.data.meta.links;
        await this.filterAndSortItems();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    async getTemplates(getParams) {
      try {
        let resp = await api.hrTemplates();
        this.hrTemplates = resp.data.data;
        if (getParams.filterTemplates) {
          this.filterTemplates.splice(0, 1, parseInt(getParams.filterTemplates));
          this.filterAndSortItems();
        }
      } catch (e) {
        console.error(e);
      }
    },
    async selectItemsPerPage(event) {
      this.loading = true;
      try {
        event.number > 20 ? this.activePage = 1 : this.activePage
        let resp = await api.getCatalog(this.activePage, event.number);
        this.allItems = resp.data.data;
        this.pages = resp.data.meta.links;
        await this.filterAndSortItems();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async getIdp() {
      let employeePernumber = '0';
      if (this.$route && this.$route.query.pernumber) {
        employeePernumber = this.$route.query.pernumber;
      } else if (window.IDP.pernumber && window.IDP.role === 'admin') {
        employeePernumber = window.IDP.pernumber;
      } else if (window.IDP.pernumber && (window.IDP.role === '' || window.IDP.role === 'employee')) {
        employeePernumber = window.IDP.pernumber;
      }

      if (employeePernumber !== '0') {
        this.loading = true;
        try {
          let resp = await api.getIDP(employeePernumber, [this.currentYear]);
          let idp = resp.data;
          this.IDP = {
            id: idp.activeIdp.id,
            status: idp.activeIdp.status,
          };

        } catch (e) {
          console.error(e);
        }
        this.loading = false;
      }
    },
    async getEmployeesFromEmployeeList() {
      let employeePernumbers = [];
      if (this.$route && this.$route.query.pernumbers) {
        employeePernumbers = this.$route.query.pernumbers.split(',');
        this.employeesFromHr = employeePernumbers;
      }
    },
    showViewModalByClick(item) {
      this.contextMenu.activityId = item.id;
      this.contextMenu.activityType = item.type;
      this.contextMenuActivity = {
        activityId: item.id,
        activityType: item.type,
        name: item.name,
        isValid: item.is_valid
      };
      this.$nextTick(() => this.showViewModal());
    },
    goToMyIDP() {
      this.$bvModal.hide('alert-assign-modal-list');
      this.$router.push('/employee');
      window.location.reload();
    },
    openAssignmentsModal() {
      this.$nextTick(() => this.$bvModal.show('assignment-view-modal'));
    },
    async searchCompetence(e) {
      const searchingString = e.target.value;

      if (searchingString.length > 0) {
        this.searching = true;
        this.filterCompetenceName = searchingString;
        await this.filterAndSortItems();
      } else {
        this.$refs['competence-input'].value = '';
        this.filterCompetenceName = '';
        this.searching = false;
        await this.filterAndSortItems();
      }
    }
  },
  mounted() {
    if(window.IDP.role) {
      this.role = window.IDP.role;
    }

    if(!window.IDP.role || window.IDP.role === 'employee') {
      this.pernumber = window.IDP.pernumber;
    }

    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search);

    if(!window.IDP.role || window.IDP.role === 'employee') {
      this.group = 'mandatory'
    }

    if(params.get('group')) {
      this.group = params.get('group');
    }

    if(params.get('pernumber')) {
      this.pernumber = params.get('pernumber');
    }

    // if(params.get('p')) {
    //   this.activePage = params.get('p');
    // }

    let formatMethodArr = window.IDP.formatMethod;
    for (let code of formatMethodArr) {
      this.formatsAndMethods.push({id: code, code: code,});
    }
    let typesArr = window.IDP.commonActivityTypes;
    for (let code of typesArr) {
      this.types.push({id: code, code: code,});
    }

    this.getCompetences(new Set([]));
    this.getActivities(this.activePage);
    // this.getTemplates(currState);
    this.getIdp();
    this.getEmployeesFromEmployeeList();
  }
}
</script>

<style scoped>

</style>
